var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.pageLoading),expression:"pageLoading"}],staticClass:"molecule"},[_vm._v(" 大小分子学习 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }